if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      this.autoplaySpeed = 4000;
      this.autoplay = null;

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
          this.restartAutoplay();
        });
      }

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
          this.restartAutoplay();
        });
      }
    }

    connectedCallback() {
      if (!this.slider || this.length <= 1) return;

      this.setupSlider();
      this.startAutoplay();

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
      this.updateSliderPosition(false);
    }

    setupSlider() {
      this.slider.style.display = 'flex';
      this.slider.style.flexWrap = 'nowrap';
      this.slider.style.width = `${this.length * 100}%`;
      this.slider.style.transition = 'transform 1.2s ease';
      this.slider.style.transform = 'translateX(0)';

      this.content.forEach((item) => {
        item.style.flex = `0 0 ${100 / this.length}%`;
        item.style.maxWidth = `${100 / this.length}%`;
      });

      this.updateSliderPosition(false);
    }

    changeSlide(direction) {
      if (!this.slider || this.length <= 1) return;

      if (direction === 'next') {
        this.index++;
      } else if (direction === 'prev') {
        this.index--;
      }

      if (this.index >= this.length) {
        this.index = 0;
      } else if (this.index < 0) {
        this.index = this.length - 1;
      }

      this.updateSliderPosition(true);
    }

    updateSliderPosition(animate = true) {
      if (!animate) {
        this.slider.style.transition = 'none';
      } else {
        this.slider.style.transition = 'transform 1.2s ease';
      }

      this.slider.style.transform = `translateX(-${100 / this.length * this.index}%)`;

      if (!animate) {
        requestAnimationFrame(() => {
          this.slider.style.transition = 'transform 1.2s ease';
        });
      }
    }

    startAutoplay() {
      if (this.autoplay || this.length <= 1) return;

      this.autoplay = setInterval(() => {
        this.changeSlide('next');
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplay) {
        clearInterval(this.autoplay);
        this.autoplay = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

  }

  if (typeof customElements.get('announcement-bar') == 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}